<template>
  <v-container>
    <material-card elevation="5">
      <v-layout px-3 slot="header">
        <v-flex mt-2 pl-3 align-center justify-center>
          <div class="headline pt-3 pb-4">Statystyki</div>
        </v-flex>
      </v-layout>

      <v-layout wrap>
        <v-flex v-if="isPartner()" px-2 sm12 md12 lg6>
          <card-usages-chart />
        </v-flex>

        <v-flex v-if="isPartner()" px-2 sm12 md12 lg6>
          <benefit-values-chart />
        </v-flex>

        <v-flex v-if="isOfficial()" px-2 sm12 md12 lg4>
          <card-usages-chart />
        </v-flex>

        <v-flex v-if="isOfficial()" px-2 sm12 md12 lg4>
          <benefit-values-chart />
        </v-flex>

        <!-- <v-flex v-if="isOfficial()" md12 sm12 lg5 offset-lg1>
        <partners-created-chart />
        </v-flex>-->

        <v-flex v-if="isOfficial()" px-2 sm12 md12 lg4>
          <activated-cards-chart />
        </v-flex>

        <v-flex v-if="isOfficial()" px-2 xs12 sm6 lg4>
          <material-stats-card
            color="lime"
            icon="mdi-store"
            title="Partnerzy"
            :value="count.toString()"
          />
        </v-flex>

        <v-flex v-if="isOfficial()" px-2 xs12 sm6 lg4>
          <material-stats-card
            color="purple"
            icon="mdi-eye"
            title="Profile oczekujące na potwierdzenie"
            :value="unconfirmedProfiles.toString()"
          />
        </v-flex>

        <v-flex v-if="isOfficial()" px-2 xs12 sm6 lg4 offset-sm3 offset-lg0>
          <material-stats-card
            color="success"
            icon="mdi-wallet-giftcard"
            title="Karty oczekujące na wydanie"
            :value="readyCards.toString()"
          />
        </v-flex>
      </v-layout>
    </material-card>

    <card-use-modal
      v-if="isPartner()"
      :show="cardUseModalMixin.cardUseModal"
      :cardnumber="cardUseModalMixin.cardNumber"
      @close="hideModal"
    ></card-use-modal>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import { isOfficial, isPartner } from '@witkac/kartamiejska-shared';

import MaterialCard from '@/components/material/Card';
import CardUsagesChart from '@/components/charts/CardUsagesChart';
import BenefitValuesChart from '@/components/charts/BenefitValuesChart';
import PartnersCreatedChart from '@/components/charts/PartnersCreatedChart';
import ActivatedCardsChart from '@/components/charts/ActivatedCardsChart';
import MaterialStatsCard from '@/components/material/StatsCard';
import { cardUseModalMixin } from '@/mixins/cardUseModal';
import { eventCardReaderMixin } from '@/mixins/eventCardReader';
import CardUseModal from '@/views/cardUsage/modal.vue';

// @vuese
// Podsumowanie
// @group Dashboard
export default {
  components: {
    CardUsagesChart,
    BenefitValuesChart,
    PartnersCreatedChart,
    ActivatedCardsChart,
    MaterialStatsCard,
    MaterialCard,
    CardUseModal
  },
  mixins: [cardUseModalMixin, eventCardReaderMixin],
  methods: {
    // @vuese
    // Sprawdza czy użytkownik jest partnerem
    isPartner,
    // @vuese
    // Sprawdza czy użytkownik jest urzędnikiem
    isOfficial
  },
  computed: {
    ...mapState({
      count: state => state.partners.count,
      unconfirmedProfiles: state => state.stats.unconfirmedProfiles,
      readyCards: state => state.stats.readyCards
    })
  }
};
</script>
